<div class="ne-button {dark ? 'ne-dark' : 'ne-light'}">
  <slot></slot>
</div>

<style>
  .ne-button {
    cursor: pointer;
    font-size: .875rem;
    letter-spacing: .035714286em;
    border-width: .142857143em;
    border-style: solid;
    border-radius: 3em;
    padding: .5em;
    min-width: 11.4286em;
    font-weight: 600;
    text-align: center;
    margin: 5px 20px;
  }

  @media (min-width: 540px) {
    .ne-button {
      margin: 5px;
    }
  }

  .ne-light {
    border-color: #404953;
    color: #404953;
    background-color: #fff;
  }

  .ne-dark {
    border-color: #404953;
    color: #fff;
    background-color: #404953;
  }
</style>

<script>
  export let dark = false;
</script>
